// extracted by mini-css-extract-plugin
export default {"container":"complate-icon_container__-dSxe","show":"complate-icon_show__lSBYI"};